/* eslint-disable no-multi-spaces, id-length */
const iconSizeMap = {
  xsmall: '0.625rem',
  // 10px hardcoded
  small: '0.75rem',
  // 12px hardcoded
  base: '0.875rem',
  // 14px font.size.text.base
  medium: '1rem',
  // 16px font.size.text.medium
  large: '1.125rem',
  // 18px font.size.text.large
  xlarge: '1.5rem' // 24px font.size.display.medium
};
const iconMobileSizeMap = {
  xsmall: '0.75rem',
  // 12px hardcoded
  small: '0.875rem',
  // 14px font.size.text.small
  base: '1rem',
  // 16px font.size.text.base
  medium: '1.25rem',
  // 20px font.size.text.medium
  large: '1.375rem',
  // 22px font.size.text.large
  xlarge: '1.5rem' // 24px font.size.display.medium
};

/** Gets the icons size */
const getIconSize = (size, isMobile) => {
  if (size) {
    // check if size can be mapped
    if (iconSizeMap[size]) return isMobile ? iconMobileSizeMap[size] : iconSizeMap[size];
    // if the size is `2x`, `3x`, etc. then map to rems
    if (size.endsWith('x') && !size.endsWith('px')) return size.replace('x', 'rem');
    // use the provided size directly
    return size;
  }
  return undefined;
};

export { getIconSize as g };
//# sourceMappingURL=getIconSize-CQug84dd.js.map
